/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { Injectable } from '@angular/core';
import { completedClusterAction } from '@app/common/rxjs-operators/completed-cluster-action';
import { ClusterId } from '@shared/types/cluster';
import { ActionName } from '@shared/types/cluster-actions';
import { NodeConfiguration, NodeId } from '@shared/types/node';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ClusterActionService } from './cluster-action.service';
import { WebSocketConnection } from './websocket-connection.service';

@Injectable({ providedIn: 'root' })
export class NodeApi {
  constructor(
    private ws: WebSocketConnection,
    private clusterActions: ClusterActionService,
  ) {}

  configuration(clusterId: string, nodeConsistentIdHash: string): Observable<NodeConfiguration> {
    return this.ws.getTopic<NodeConfiguration>(`/topic/cluster/node-config/${clusterId}/${nodeConsistentIdHash}`);
  }

  getNodeConfiguration(clusterId: ClusterId, nodeId?: NodeId): Observable<NodeConfiguration> {
    return this.clusterActions
      .dispatch(ActionName.NODE_CONFIGURATION, { nodeIds: nodeId ? [nodeId] : [], clusterId })
      .pipe(
        map((res) => res.job),
        completedClusterAction(),
        map(({ result }) => JSON.parse(result) as NodeConfiguration),
      );
  }

  triggerGC(clusterId: ClusterId, nodeId: NodeId) {
    return this.clusterActions.dispatch(ActionName.TRIGGER_NODE_GC, { nodeIds: [nodeId], clusterId }).pipe(
      map((res) => res.job),
      completedClusterAction(),
    );
  }

  getThreadDump(clusterId: ClusterId, nodeId: NodeId) {
    return this.clusterActions.dispatch(ActionName.GET_THREAD_DUMP, { nodeIds: [nodeId], clusterId }).pipe(
      map((res) => res.job),
      completedClusterAction(),
      map((res) => res.result),
    );
  }
}
